import Memograph from "@/components/Memograph";
import { TID } from "@/lib/testIds";

export default function MemographPage() {
  return (
    <div data-testid={TID.memographPage} className="space-y-4">
      <p className="text-sm text-neutral-400 max-w-2xl">
        Memoria organizzativa a 3 livelli. Interroga <span className="font-mono text-neutral-300">semantico</span>,{" "}
        <span className="font-mono text-neutral-300">grafo</span> e <span className="font-mono text-neutral-300">file</span>:
        ogni risultato riporta <span className="text-[#EDEDED]">nodo</span> e{" "}
        <span className="text-[#EDEDED]">sorgente</span>.
      </p>
      <Memograph />
      <div className="font-mono text-[10px] text-neutral-500">
        suggerimenti · prova: <span className="text-neutral-300">&quot;intimoaround&quot;</span>, <span className="text-neutral-300">&quot;structura&quot;</span>, <span className="text-neutral-300">&quot;dottrina&quot;</span>, <span className="text-neutral-300">&quot;decisione&quot;</span>, <span className="text-neutral-300">&quot;clickup&quot;</span>
      </div>
    </div>
  );
}
